<div
  class="mb-3 row"
  [hidden]="state.hidden"
  [attr.data-automation]="config.dataAutomation"
  [ngClass]="{
    'has-feedback': showValidation || isFormSubmitted,
    'ziro-forms-error': validationState === ValStates.INVALID,
    'ziro-forms-warning':
      validationState === ValStates.PENDING || validationState === ValStates.WARNING || misconfigurationFeedbackMessage,
    'ziro-forms-success': validationState === ValStates.VALID && showAsyncValidation,
  }"
>
  <label
    class="ziro-forms-label col-form-label col-3 text-end"
    [attr.data-automation]="config.dataAutomation + '-label'"
  >
    @if (state.required) {
      <span class="text-danger ziro-horizontal-form-asterisk">*</span>
    }
    <span>{{ getLabel() | translate }}</span>
  </label>
  @if (fieldData) {
    <div class="col-9">
      <div
        class="form-check"
        [ngClass]="{ 'has-warning': showWarningMessage() }"
        [attr.data-automation]="'ziro-radio-option-voicemail'"
      >
        <input
          class="form-check-input"
          type="radio"
          [name]="config.dataAutomation"
          [attr.id]="config.dataAutomation + '-' + 'voicemail' + '-' + uniqueRadioId"
          [value]="true"
          [(ngModel)]="fieldData.forwardToVoicemail"
          [attr.data-automation]="'ziro-radio-option-input-voicemail'"
          #ngModelDir="ngModel"
          (ngModelChange)="onChange($event, ngModelDir)"
        />
        <label
          class="form-check-label"
          [attr.for]="config.dataAutomation + '-' + 'voicemail' + '-' + uniqueRadioId"
          [attr.data-automation]="'ziro-radio-option-label-voicemail'"
        >
          <i [ngClass]="ziroIcons.VOICEMAIL_SMALL"></i>
          {{ 'tkey;shared.dnWizard.dnDetails.dnVoicemail.voicemail.label' | translate }}
        </label>
      </div>
      <div
        class="form-check"
        [ngClass]="{ 'has-warning': showWarningMessage() }"
        [attr.data-automation]="'ziro-radio-option-destination'"
      >
        <input
          class="form-check-input"
          type="radio"
          [name]="config.dataAutomation"
          [attr.id]="config.dataAutomation + '-' + 'destination' + '-' + uniqueRadioId"
          [value]="false"
          [(ngModel)]="fieldData.forwardToVoicemail"
          #ngModelDir="ngModel"
          (ngModelChange)="onChange($event, ngModelDir)"
          [attr.data-automation]="'ziro-radio-option-input-destination'"
        />
        <input
          type="text"
          class="text-field form-control"
          [name]="config.dataAutomation"
          [ngClass]="{ 'alert-danger': showErrorMessage() }"
          [attr.id]="config.dataAutomation + '-input'"
          [placeholder]="'tkey;shared.device.phone.call_forward.placeholder' | translate"
          [attr.data-automation]="'ziro-text-input'"
          [value]="fieldData.destination"
          [disabled]="fieldData.forwardToVoicemail"
          [(ngModel)]="fieldData.destination"
          #ngModelDir="ngModel"
          (ngModelChange)="onChange($event, ngModelDir)"
        />
      </div>
      <div class="ziro-forms-feedback-area">
        <div
          class="ziro-forms-validation-message text-danger"
          data-automation="ziro-forms-validation-message"
          [hidden]="validationState !== ValStates.INVALID"
        >
          {{ 'tkey;validators.global.required.error' | translate }}
        </div>
        <div
          class="ziro-forms-validation-message text-danger"
          data-automation="ziro-forms-error-message"
          [hidden]="!showErrorMessage()"
        >
          {{ 'tkey;validators.global.error.pattern' | translate }}
        </div>
        <div
          class="ziro-forms-validation-message text-warning"
          [ngClass]="{ 'd-inline': config.autogeneration?.inline }"
          data-automation="ziro-forms-warning-message"
          [hidden]="!showWarningMessage()"
        >
          {{ 'tkey;shared.section.primarydn.cf.voicemail.warning' | translate }}
        </div>
      </div>
    </div>
  }
</div>
